<template>
  <div class="services">
    <b-row>
      <b-col cols="12" lg="8" offset-lg="2">
        <div class="services-item" v-for="(item, index, i) in data.servicescat" :key="i">
          <b-row no-gutters>
            <b-col cols="12" md="6">
              <div class="img">
                <img :src="item.img.url" alt />
              </div>
            </b-col>
            <b-col cols="12" md="6">
              <div class="content">
                <h2 class="ttl">{{item.title}}</h2>
                <p class="description">{{cutText(item.text)}}</p>
                <div
                  class="button-container d-flex justify-content-center justify-content-lg-start align-items-center"
                >
                  <a href="#">
                    Смотреть все услуги
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                    >
                      <path d="M0 8V6H12L8 2L9 0L16 7L9 14L8 12L12 8H0Z" fill="#00A65D" />
                    </svg>
                  </a>
                </div>
              </div>
            </b-col>
          </b-row>
          <router-link
            class="stretched-link"
            :to="{path: data.url.replace('/api', ''), query: { type: item.title }}"
            tag="a"
          ></router-link>
          <div class="shadow-text d-none d-lg-block">{{item.text2}}</div>
          <!-- <div class="shadow-bg d-none d-md-block">
						<img src="@/assets/img/circle.png" alt="">
          </div>-->
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      activeTab: null,
      data: {}
    };
  },
  beforeCreate() {
    axios
      .get(`${this.$root.routLink}/?ajax&act=servicesCat`, {
        responseType: "json"
      })
      .then(({ data }) => {
        this.data = JSON.parse(data.addons);
      });
  },
  methods: {
    cutText(value, symbolsCount = 120) {
      if (!value) {
        return "";
      }
      return value.length > symbolsCount
        ? value.slice(0, symbolsCount - 3) + "..."
        : value;
    }
  }
};
</script>

<style lang="scss" scoped>
.services {
  padding-top: 70px;
  @media only screen and (max-width: $md),
    only screen and (max-device-width: $md) {
    padding-top: 0;
  }

  &-item {
    position: relative;
    z-index: 1;
    margin-bottom: 100px;
    transition: all 0.3s ease-in-out;

    * {
      background-color: transparent;
    }
    @media only screen and (max-width: $sm),
      only screen and (max-device-width: $sm) {
      margin-bottom: 30px;
    }
    * {
      transition: all 0.3s ease-in-out;
    }

    &:last-child {
      margin-bottom: 0;
    }

    .img {
      height: 300px;
      border-radius: 6px 0 0 6px;
      filter: grayscale(0.5);
      transition: all 0.3s ease-in-out;
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
        border-radius: 6px 6px 0 0;
        height: 140px;
      }
      img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 6px 0 0 6px;
        @media only screen and (max-width: $sm),
          only screen and (max-device-width: $sm) {
          border-radius: 6px 6px 0 0;
        }
      }
    }

    .content {
      padding: 30px 30px 35px 30px;
      background-color: #ffffff;
      transition: all 300ms ease-in-out;
      border-radius: 0 6px 6px 0;
      height: 300px;
      filter: drop-shadow(0px 0px 44px rgba(162, 162, 162, 0.4));
      @media only screen and (max-width: $sm),
        only screen and (max-device-width: $sm) {
        padding: 20px 15px;
        border-radius: 0 0 6px 6px;
        height: 100%;
      }

      .ttl {
        font-weight: 700;
        font-size: 30px;
        line-height: 110.1%;
        color: #000000;
        margin-bottom: 33px;
        @media only screen and (max-width: $sm),
          only screen and (max-device-width: $sm) {
          font-size: 30px;
          margin-bottom: 10px;
        }
      }

      .description {
        font-size: 16px;
        line-height: 120.1%;
        color: #000000;
        margin-bottom: 33px;
        @media only screen and (max-width: $sm),
          only screen and (max-device-width: $sm) {
          font-size: 14px;
          margin-bottom: 20px;
        }
      }

      .button-container {
        background-color: #ffffff;
        border: 2px solid $activeColor;
        box-sizing: border-box;
        border-radius: 6px;
        padding: 16px 0;

        @media only screen and (max-width: $sm),
          only screen and (max-device-width: $sm) {
          margin-bottom: 20px;
        }

        a {
          font-weight: 700;
          font-size: 14px;
          line-height: 18px;
          color: $activeColor;
          padding-left: 73px;
          @media only screen and (max-width: $lg),
            only screen and (max-device-width: $lg) {
            padding-left: 35px;
          }
          @media only screen and (max-width: $md),
            only screen and (max-device-width: $md) {
            padding-left: 0;
          }

          svg {
            margin-left: 9px;
            margin-bottom: 2px;
          }
        }
      }
    }

    .shadow-text {
      white-space: nowrap;
      font-weight: 700;
      font-size: 100px;
      line-height: 110.1%;
      color: #eeeeee;
      position: absolute;
      top: -60px;
      left: -80px;
      z-index: -1;
      pointer-events: none;
      @media only screen and (max-width: $lg),
        only screen and (max-device-width: $lg) {
        font-size: 80px;
        top: -60px;
      }
    }

    .shadow-bg {
      position: absolute;
      z-index: -1;
      left: -130px;
      top: 3px;
      pointer-events: none;
    }
    &:hover {
      box-shadow: 0px 0px 44px rgba(0, 166, 93, 0.3);
      .img {
        filter: grayscale(0);
      }

      .ttl,
      .description {
        color: $activeColor;
      }
      .button-container {
        background-color: $activeColor;
        a {
          color: $defaultColor;

          svg {
            margin-left: 35px;

            path {
              fill: $defaultColor;
            }
          }
        }
      }
    }
  }
}
</style>